/* Market list feature (list, detail, form). Shared vocabulary lives in
 * common.js; requisition phrasing lives in requisitions.js. */
const marketlist = {
  // --- List page -------------------------------------------------------------
  'Failed to load market lists.': 'Gagal memuat daftar belanja pasar.',
  'Market list': 'Daftar belanja pasar',
  'Daily fresh-produce ordering sheets — compare vendor quotes and finalize into requisitions.': 'Lembar pemesanan bahan segar harian — bandingkan penawaran vendor dan finalisasi menjadi permintaan barang.',
  'New market list': 'Daftar belanja pasar baru',
  'Search by number, title or creator…': 'Cari berdasarkan nomor, judul, atau pembuat…',
  "Couldn't load market lists": 'Tidak dapat memuat daftar belanja pasar',
  'No matching market lists': 'Tidak ada daftar belanja pasar yang cocok',
  'No market lists yet': 'Belum ada daftar belanja pasar',
  'Build your first daily market list to capture vendor quotes against par levels.': 'Buat daftar belanja pasar harian pertama Anda untuk mencatat penawaran vendor terhadap level par.',
  'Outlet': 'Outlet',
  'Market date': 'Tanggal belanja',

  // Status labels (server enum display values)
  'In progress': 'Sedang berjalan',
  'Finalized': 'Difinalisasi',

  // --- Detail page -----------------------------------------------------------
  'Market list not found.': 'Daftar belanja pasar tidak ditemukan.',
  "Couldn't load market list": 'Tidak dapat memuat daftar belanja pasar',
  'Back to market list': 'Kembali ke daftar belanja pasar',
  'Finalized into {count} requisition(s)': 'Difinalisasi menjadi {count} permintaan barang',
  'Could not finalize': 'Tidak dapat memfinalisasi',
  'Purchasing started': 'Pembelian dimulai',
  'Could not start purchasing': 'Tidak dapat memulai pembelian',
  'Market list reopened to draft': 'Daftar belanja pasar dibuka kembali sebagai draf',
  'Could not reopen': 'Tidak dapat membuka kembali',
  'Market list cancelled': 'Daftar belanja pasar dibatalkan',
  'Could not cancel': 'Tidak dapat membatalkan',
  'Market list deleted': 'Daftar belanja pasar dihapus',
  'Reopen': 'Buka kembali',
  'Start purchasing': 'Mulai pembelian',
  'Finalize': 'Finalisasi',
  'Purchasing started by': 'Pembelian dimulai oleh',
  'Finalized by': 'Difinalisasi oleh',
  'This market list is a draft. Add the items to order, then start purchasing to capture vendor prices and assign a vendor per line.': 'Daftar belanja pasar ini masih draf. Tambahkan barang yang akan dipesan, lalu mulai pembelian untuk mencatat harga vendor dan menetapkan vendor per baris.',
  'Purchasing is in progress. Edit the list to capture prices, assign vendors, or substitute items. When buying is complete, a purchasing officer finalizes it into one requisition per assigned vendor.': 'Pembelian sedang berjalan. Ubah daftar untuk mencatat harga, menetapkan vendor, atau mengganti barang. Setelah belanja selesai, petugas pembelian memfinalisasinya menjadi satu permintaan barang per vendor yang ditetapkan.',
  'This market list was cancelled': 'Daftar belanja pasar ini dibatalkan',
  'on {date}': 'pada {date}',
  'Reason: {reason}': 'Alasan: {reason}',
  'They are routed through the normal approval pipeline.': 'Dokumen tersebut diteruskan melalui alur persetujuan normal.',
  'Lines to order': 'Baris untuk dipesan',
  'Vendors assigned': 'Vendor ditetapkan',
  'Generated requisitions': 'Permintaan barang yang dihasilkan',
  'One requisition per assigned vendor, routed for approval.': 'Satu permintaan barang per vendor yang ditetapkan, diteruskan untuk persetujuan.',
  'Items & quotes': 'Barang & penawaran',
  'Vendor prices captured for the day; the assigned vendor fulfils each line.': 'Harga vendor yang dicatat hari itu; vendor yang ditetapkan memenuhi setiap baris.',
  'The vendor quotes and assignments captured for this market list.': 'Penawaran vendor dan penetapan yang dicatat untuk daftar belanja pasar ini.',
  'Par': 'Par',
  'On hand': 'Tersedia',
  'Vendor quotes': 'Penawaran vendor',
  'Cheapest': 'Termurah',
  'Assigned': 'Ditetapkan',
  'Assigned to': 'Ditetapkan kepada',
  'at {price}/unit': 'dengan harga {price}/satuan',
  'Finalize market list': 'Finalisasi daftar belanja pasar',
  'This creates one requisition per assigned vendor for the ordered lines. The market list becomes read-only.': 'Ini membuat satu permintaan barang per vendor yang ditetapkan untuk baris yang dipesan. Daftar belanja pasar menjadi hanya-baca.',
  'Submit the requisitions for approval': 'Ajukan permintaan barang untuk persetujuan',
  'Leave unchecked to create them as drafts so prices can still be refined before submitting.': 'Biarkan tidak dicentang untuk membuatnya sebagai draf agar harga masih dapat disesuaikan sebelum diajukan.',
  'Cancel market list': 'Batalkan daftar belanja pasar',
  'Mark this market list as cancelled. You can still delete a draft afterwards.': 'Tandai daftar belanja pasar ini sebagai dibatalkan. Anda masih dapat menghapus draf setelahnya.',
  'Reason (optional)': 'Alasan (opsional)',
  'Delete market list': 'Hapus daftar belanja pasar',
  "Permanently delete this market list. This can't be undone.": 'Hapus daftar belanja pasar ini secara permanen. Tindakan ini tidak dapat dibatalkan.',

  // --- Form page ---------------------------------------------------------------
  'Only draft or in-progress market lists can be edited.': 'Hanya daftar belanja pasar berstatus draf atau sedang berjalan yang dapat diubah.',
  'Could not load market list': 'Tidak dapat memuat daftar belanja pasar',
  '— Select vendor —': '— Pilih vendor —',
  '— Select outlet —': '— Pilih outlet —',
  'That item is already on the list.': 'Barang itu sudah ada di daftar.',
  'Choose an outlet first.': 'Pilih outlet terlebih dahulu.',
  'No par levels configured for this outlet.': 'Belum ada level par yang diatur untuk outlet ini.',
  'Loaded {count} item(s) from par levels': '{count} barang dimuat dari level par',
  'Could not load suggestions': 'Tidak dapat memuat saran',
  'Choose an outlet.': 'Pilih outlet.',
  'Set an order quantity on at least one line before starting purchasing.': 'Atur kuantitas pesanan pada minimal satu baris sebelum memulai pembelian.',
  'Set an order quantity on at least one line before finalizing.': 'Atur kuantitas pesanan pada minimal satu baris sebelum finalisasi.',
  'Assign a vendor to every ordered line ({count} still need one).': 'Tetapkan vendor untuk setiap baris yang dipesan ({count} masih membutuhkan).',
  'Market list updated': 'Daftar belanja pasar diperbarui',
  'Could not save market list': 'Tidak dapat menyimpan daftar belanja pasar',
  'Could not finalize market list': 'Tidak dapat memfinalisasi daftar belanja pasar',
  'Edit market list (purchasing)': 'Ubah daftar belanja pasar (pembelian)',
  'Edit market list': 'Ubah daftar belanja pasar',
  "Build the day's order, capture vendor prices as you buy, and assign a vendor per line. A purchasing officer finalizes it into requisitions when purchasing is complete.": 'Susun pesanan hari itu, catat harga vendor saat berbelanja, dan tetapkan vendor per baris. Petugas pembelian memfinalisasinya menjadi permintaan barang setelah pembelian selesai.',
  'e.g. Daily produce — Main kitchen': 'mis. Bahan segar harian — Dapur utama',
  "Market lists are local purchases — the currency is the property's local currency and can't be changed.": 'Daftar belanja pasar adalah pembelian lokal — mata uangnya adalah mata uang lokal properti dan tidak dapat diubah.',
  'Local': 'Lokal',
  "Context for the day's market run (optional)": 'Konteks untuk belanja pasar hari itu (opsional)',
  'Items & vendor quotes': 'Barang & penawaran vendor',
  'Load from par': 'Muat dari par',
  'Search the catalog to add an item…': 'Cari katalog untuk menambah barang…',
  'Search name or SKU…': 'Cari nama atau SKU…',
  'Searching…': 'Mencari…',
  'No catalog matches': 'Tidak ada katalog yang cocok',
  'Search catalog…': 'Cari katalog…',
  'Catalog item': 'Barang katalog',
  'Add catalog item': 'Tambah barang katalog',
  'Untitled item': 'Barang tanpa nama',
  'Suggested': 'Disarankan',
  'Remove item': 'Hapus barang',
  'Order qty': 'Kts pesanan',
  'Cost centre': 'Pusat biaya',
  'GL account': 'Akun GL',
  'Line total {amount}': 'Total baris {amount}',
  'No quotes yet — add a vendor and price.': 'Belum ada penawaran — tambahkan vendor dan harga.',
  'Vendor…': 'Vendor…',
  'Search vendors…': 'Cari vendor…',
  'No vendor matches': 'Tidak ada vendor yang cocok',
  'Quote vendor': 'Vendor penawaran',
  'Note (optional)': 'Catatan (opsional)',
  'Assign': 'Tetapkan',
  'Remove quote': 'Hapus penawaran',
  'Add vendor quote': 'Tambah penawaran vendor',
  '{count} line(s) to order · est. total': '{count} baris untuk dipesan · perkiraan total',
  'Finalize into requisitions': 'Finalisasi menjadi permintaan barang',
};

export default marketlist;
